module.exports = __webpack_public_path__ + "static/media/rebirth_10.cbb14dea.jpg";